import { isValidObject, isValidString } from './utils';

// Changes every 16 minutes
export const getCacheValue = () => {
  const dateString = Date.now().toString();
  return dateString.slice(0, 7);
};

export const validateResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP Status ${response.status} ${response.statusText}`);
  }
};

// TODO: Improve error messages. The most common unhappy scenario, where a script
// doesn't have a satisfying version in the registry, will result in a very
// confusing & unintuitive series of error messages right now.
export const validateData = (data, bundleObj) => {
  if (!isValidObject(data)) {
    throw new Error('Invalid Response Data');
  }

  if (!isValidString(data.name) && !isValidString(data.version)) {
    throw new Error('Name and version both missing. Probably unable to find script with given name and version range in the script registry.');
  }

  if (!isValidString(data.name)) {
    throw new Error('Name Missing');
  }

  if (!isValidString(data.version)) {
    throw new Error('Version Missing');
  }

  if (!isValidObject(bundleObj)) {
    throw new Error('Invalid Script Bundle');
  }

  if (!isValidObject(bundleObj.attributes)) {
    throw new Error('Script Attributes Missing');
  }

  if (!isValidObject(bundleObj.classifications)) {
    throw new Error('Script Classifications Missing');
  }

  if (!isValidString(bundleObj.attributes.src)) {
    throw new Error('Script Source Missing');
  }
};

const fetchScriptData = ({
  fetchFn,
  url,
  environment,
  name,
  version,
}) => {
  const params = new URLSearchParams();
  params.append('name', name);
  params.append('version', version);
  params.append('environment', environment);
  params.append('cache', getCacheValue());

  return fetchFn(`${url}?${params.toString()}`)
    .then((response) => {
      try {
        validateResponse(response);

        return response.json();
      } catch (error) {
        return response.text().then((text) => {
          throw new Error(text);
        });
      }
    })
    .then((data) => {
      let bundleObj = null;
      try {
        bundleObj = JSON.parse(data.bundle);
      } catch (error) {
        // ignore
      }

      validateData(data, bundleObj);

      return {
        name: data.name,
        version: data.version,
        attributes: bundleObj.attributes,
        classifications: bundleObj.classifications,
      };
    });
};

export default fetchScriptData;
